import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_FI.json';
import guides from './MEDITATION_GUIDES_FI.json';

export const MEDITATION_DATA_FI: ServiceData = {
  audios,
  guides,
};
